// extracted by mini-css-extract-plugin
module.exports = {"heading":"text_heading__2DR53","sub__heading":"text_sub__heading__XglPH","small__text":"text_small__text__JPH1K"};